import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Routes, Route } from 'react-router-dom'; // ✅ Only Routes and Route
import { HelmetProvider } from 'react-helmet-async';
import { usePageTracking } from './hooks/usePageTracking';

import Navbar from './components/Navbar';
import GlobalStyles from './styles/globalStyles';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import TestimonialsPage from './pages/TestimonialPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import CategoryBlogPage from './pages/CategoryBlogPage';
import ContactPage from './pages/ContactPage';
import PricingPage from './pages/PricingPage';
import SmsPortalIframe from './pages/SmsPortalIframe';

const theme = {
  colors: {
    primary: '#105090',
    secondary: '#2090B0',
    text: '#333333',
    background: '#FFFFFF',
    lightGray: '#F5F5F5',
  },
  fonts: {
    main: "'Sora', 'Segoe UI', sans-serif",
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '1024px',
    lg: '1200px',
  },
};

function App() {
  usePageTracking(); // ✅ safe to use now

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:postId" element={<BlogPostPage />} />
          <Route path="/blog/category/:category" element={<CategoryBlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/sms-portal" element={<SmsPortalIframe />} />
        </Routes>
        <WhatsAppButton />
        <Footer />
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
